<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="section">
          <div class="section-content padding-top-20">
            <PlaybookSectionVideos :videos = videoData videoGroup = "READING_DATA" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PlaybookSectionVideos from "@/components/playbook/PlaybookSectionVideos";

export default {
  name: "ReadingTheData",
  components : {PlaybookSectionVideos},
  data () {
    return {
      videoData : [
        {
          id: 0,
          title: this.$t('PLAYBOOK.readingTheData.readSessionSummary'),
          src: 'https://www.youtube-nocookie.com/embed/hUwgvn2OxPI?rel=0'
        },
        {
          id: 1,
          title: this.$t('PLAYBOOK.readingTheData.navigateDashboard'),
          src: 'https://www.youtube-nocookie.com/embed/zSq1551TrV8?rel=0'
        }
      ]
    }
  }
}
</script>

<style>
.container-fluid .img-fluid{
   height: 500px;
 }

 .carousel.slide{
   padding: 0 10%;
 }

 .video-wrapper{
position: relative;
  padding-bottom: 56.25%; /* 16:9 */
  height: 0;
 }
 .video-wrapper iframe{
position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
 }
</style>